// hooks/useExamTypes.ts
import { useState, useEffect } from 'react';
import apiClient from '../services/axiosInterceptor';

export interface ExamOption {
  label: string;
  value: string;
  id: string;
}

interface ExamTypeResponse {
  id: number;
  title: string;
  name: string;
  status: 'active' | 'inactive';
}

interface ExamTypesApiResponse {
  status: 'success' | 'error';
  data: ExamTypeResponse[]; // ✅ Fixed: added property name 'data'
  message?: string;
}

export const useExamTypes = () => {
  const [examTypes, setExamTypes] = useState<ExamOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedExamTypeId, setSelectedExamTypeId] = useState<string | null>(null);

  useEffect(() => {
    const fetchExamTypes = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiClient.get<ExamTypesApiResponse>('exam-types');
        console.log('exam types',response.data)

        if (response.data.status === 'success') {
          const options: ExamOption[] = response.data.data.map((exam) => ({
            label: exam.title,
            value: exam.id.toString(),
            id: exam.id.toString(),
          }));

          setExamTypes(options);
          if (options.length > 0) {
            setSelectedExamTypeId(options[0].id);
          }
        } else {
          setError(response.data.message || 'Failed to load exam types.');
        }
      } catch (err: any) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          'An error occurred while fetching exam types.';
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    fetchExamTypes();
  }, []);

  return {
    examTypes,
    loading,
    error,
    selectedExamTypeId,
    setSelectedExamTypeId,
  };
};